var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sidebar-item',{attrs:{"link":{
      name: _vm.$t('sidebar.orders'),
      icon: 'tim-icons icon-delivery-fast',
      path: {name: 'supplier.order'},
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }